
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './giftgiving.json';

const GiftGiving = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Gift culture, occasions, and social etiquette vocabulary. B2 level grammar, vocabulary, and discussion exercises."
            level="B2"
            title="Gift Giving"
            image="/Images/giftgivng.webp"
            seoTitle="Free English Lesson Plans: Gift Giving"
            seoDescription="Gift culture, occasions, and social etiquette vocabulary. B2 level grammar, vocabulary, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default GiftGiving;


